/* @pareto-engineering/generator-front 1.1.1-alpha.2 */
import * as React from 'react';
import { useState, useEffect } from 'react';
import { Form, FieldArray, useFormikContext } from 'formik';
import PropTypes from 'prop-types';

// Local Definitions

import styleNames from '@pareto-engineering/bem/exports';
import { TextInput, EditorInput } from "../../../../../../f";
import { DragAndDrop } from "../../../../..";
import { InputBuilder } from "../InputBuilder";
import { ActionsContainer } from "../ActionsContainer";
import "./styles.scss";
const baseClassName = styleNames.base;
const componentClassName = 'builder-section';

/**
 * This is the component description.
 */
const Section = ({
  id,
  className: userClassName,
  style,
  index,
  handleDeleteSection
  // ...otherProps
}) => {
  const {
    values,
    setFieldValue
  } = useFormikContext();
  const section = values.sections[index];
  const handleDeleteInput = inputIndex => {
    const newInputs = [...section.inputs];
    newInputs.splice(inputIndex, 1);
    setFieldValue(`sections.${index}.inputs`, newInputs);
  };
  const handleCopyInput = inputIndex => {
    const inputToCopy = section.inputs[inputIndex];
    const newInputs = [...section.inputs, {
      ...inputToCopy,
      name: `section_${index}_input_${section.inputs.length}`
    }];
    setFieldValue(`sections.${index}.inputs`, newInputs);
  };
  const [draggableInputs, setDraggableInputs] = useState([]);
  const {
    inputs
  } = section;
  useEffect(() => {
    const items = inputs.map((input, indx) => ({
      Content: /*#__PURE__*/React.createElement(InputBuilder, {
        key: input.name,
        sectionIndex: index,
        inputIndex: indx,
        onDelete: handleDeleteInput,
        onCopy: handleCopyInput
      }),
      identifier: input.name
    }));
    setDraggableInputs(items);
  }, [inputs.length, index]);
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: [baseClassName, componentClassName, userClassName].filter(e => e).join(' '),
    style: style
  }, /*#__PURE__*/React.createElement("div", {
    className: "section-header"
  }, /*#__PURE__*/React.createElement("p", {
    className: "h4"
  }, index === 0 ? 'Form title' : `Section ${index + 1}`), index !== 0 && /*#__PURE__*/React.createElement(ActionsContainer, null, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", {
    className: "option"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "remove-section-cta",
    onClick: handleDeleteSection
  }, "Delete Section"))))), /*#__PURE__*/React.createElement(TextInput, {
    name: `sections.${index}.title`,
    placeholder: `Title of the ${index === 0 ? 'form' : 'section'}`
  }), /*#__PURE__*/React.createElement(EditorInput, {
    name: `sections.${index}.description`,
    label: `${index === 0 ? 'Form' : 'Section'} description`
  }), /*#__PURE__*/React.createElement(FieldArray, {
    name: `sections.${index}.inputs`
  }, ({
    push
  }) => /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(DragAndDrop, {
    items: draggableInputs,
    onOrderChange: reOrderedItems => {
      setDraggableInputs(reOrderedItems);
      const ids = reOrderedItems.map(e => e.identifier);
      setFieldValue(`sections.${index}.orderedInputDragIds`, ids);
    },
    key: draggableInputs.length
  }), /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "add-question-cta",
    onClick: () => push({
      name: `section_${index}_input_${section.inputs.length}`,
      label: '',
      type: 'text',
      required: false,
      options: [],
      conditionalLogic: null,
      description: ''
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "icon-container"
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon "
  }, "+")), "Add question"))));
};
Section.propTypes = {
  /**
   * The HTML id for this element
   */
  id: PropTypes.string,
  /**
   * The HTML class names for this element
   */
  className: PropTypes.string,
  /**
   * The React-written, css properties for this element.
   */
  style: PropTypes.objectOf(PropTypes.string)
};
Section.defaultProps = {
  // someProp:false
};
export default Section;